var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidFilledWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 12V14C7.33333 14.3667 7.03333 14.6667 6.66667 14.6667C6.3 14.6667 6 14.3667 6 14V12H7.33333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12V14C10.0003 14.3667 9.70033 14.6667 9.33366 14.6667C8.96699 14.6667 8.66699 14.3667 8.66699 14V12H10.0003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 7.33333V10.6667C11.3337 11.4 10.7337 12 10.0003 12H6.00033C5.26699 12 4.66699 11.4 4.66699 10.6667V7.33333C4.66699 6.6 5.26699 6 6.00033 6H10.0003C10.7337 6 11.3337 6.6 11.3337 7.33333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 7.33317V9.99984C3.33333 10.3665 3.03333 10.6665 2.66667 10.6665C2.3 10.6665 2 10.3665 2 9.99984V7.33317C2 6.9665 2.3 6.6665 2.66667 6.6665C3.03333 6.6665 3.33333 6.9665 3.33333 7.33317Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 7.33317V9.99984C14.0003 10.3665 13.7003 10.6665 13.3337 10.6665C12.967 10.6665 12.667 10.3665 12.667 9.99984V7.33317C12.667 6.9665 12.967 6.6665 13.3337 6.6665C13.7003 6.6665 14.0003 6.9665 14.0003 7.33317Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39966 5.06683H9.59969C10.1864 5.06683 10.6663 4.58683 10.6663 4.00016C10.6663 2.52683 9.47301 1.3335 7.99967 1.3335C6.52634 1.3335 5.33301 2.52683 5.33301 4.00016C5.33301 4.58683 5.81299 5.06683 6.39966 5.06683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidFilledWhite);
export default __webpack_public_path__ + "static/media/AndroidFilledWhite.9047f294115f33515af5e1573edd9153.svg";
export { ForwardRef as ReactComponent };